"use client";

import { c as _c } from "react/compiler-runtime";
import { ReplyButton } from "@/components/Comment/components/thread/actions/ReplyButton.component";
import { useComment } from "@/components/Comment/context/comment.context";
import { Translation } from "@/components/Translation/Translation.component";
export function CommentActions() {
  const $ = _c(8);
  const {
    thread,
    comment
  } = useComment();
  const repliesCount = comment.replies.comments.length;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ReplyButton />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== repliesCount || $[2] !== thread.isRepliesExpanded || $[3] !== thread.showReplies || $[4] !== thread.toggleRepliesExpanded) {
    t1 = thread.showReplies ? <button aria-expanded={thread.isRepliesExpanded} className="font-medium text-primary text-xs hover:underline focus-visible:underline focus-visible:outline-none" onClick={thread.toggleRepliesExpanded} type="button">{thread.isRepliesExpanded ? <Translation da="Skjul svar" de="Antworten ausblenden" en="Hide replies" no="Skjul svar" sv={"D\xF6lj svar"} /> : <Translation da={`Vis ${repliesCount} svar`} de={`${repliesCount} Antworten anzeigen`} en={`View ${repliesCount} ${repliesCount === 1 ? "reply" : "replies"}`} no={`Vis ${repliesCount} svar`} sv={`Visa ${repliesCount} svar`} />}</button> : null;
    $[1] = repliesCount;
    $[2] = thread.isRepliesExpanded;
    $[3] = thread.showReplies;
    $[4] = thread.toggleRepliesExpanded;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== t1) {
    t2 = <div className="flex items-center gap-3">{t0}{t1}</div>;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}